import axios from "axios";
import Vue from "vue";
import decode from 'jwt-decode';

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_URL,
  requestCert: false,
  strictSSL: false,
  rejectUnauthorized: false,
});

axiosInstance.interceptors.request.use(
  function(config) {
    try {
      const token = window.sessionStorage.token;
      if (token) {
        config.headers.Authorization = token;
      } else{
        config.headers.Authorization = "Bearer " + process.env.VUE_APP_TOKEN
      }
      
      // Para requisições de blob, garantir que o responseType seja preservado
      if (config.responseType === 'blob') {
        // Não adicionar Content-Type para requests de download
        if (!config.headers['Content-Type']) {
          delete config.headers['Content-Type'];
        }
        // Garantir Accept header apropriado para downloads
        if (!config.headers['Accept']) {
          config.headers['Accept'] = 'application/octet-stream, */*';
        }
      }
      
      return config;
    } catch (e) {
      // tratamento do erro
      console.error('Ocorreu um erro ao acessar o sessionStorage: ', e.message);
    }
  },
  function(error) {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(response => {
  if(response.status == 401){
     this.$store.dispatch("LOGOUT");
     this.$router.push({ name: "login" });
  }
  if(response.status == 429){
    this.$store.dispatch("LOGOUT");
    this.$router.push({ name: "login" });
 }
  
  // Para responses de blob, não processar o conteúdo
  if (response.config.responseType === 'blob') {
    return response;
  }
  
  return response
})


export const api = {
  get(endpoint, config = {}) {
    return axiosInstance.get(endpoint, config);
  },
  post(endpoint, body, config = {}) {
    return axiosInstance.post(endpoint, body, config);
  },
  put(endpoint, body, config = {}) {
    return axiosInstance.put(endpoint, body, config);
  },
  delete(endpoint, config = {}) {
    return axiosInstance.delete(endpoint, config);
  },
  // Método específico para downloads de blob
  downloadBlob(endpoint, config = {}) {
    return axiosInstance.get(endpoint, {
      ...config,
      responseType: 'blob',
      headers: {
        'Accept': 'application/octet-stream, */*',
        ...config.headers
      }
    });
  },
  login(body) {
    return axiosInstance.post("/api/user/authUser", body);
  },
  recuperar(body) {
    return axiosInstance.post("/api/user/resetpassword", body);
  },
  validate() {
    return axiosInstance.get('/api/user/me')
  }
};

export function getCep(cep) {
  return axios.get(`https://viacep.com.br/ws/${cep}/json/`);
}

export function decodeToken(encodedToken){
  let token = decode(encodedToken)
  if (!token.exp) {
      return null
  }

  let date = new Date(0)
  date.setUTCSeconds(token.exp)

  return date

}
 
Vue.prototype.$http = api;
if(sessionStorage.userData){
Vue.prototype.$user = JSON.parse(sessionStorage.userData)
}

Vue.prototype.$apiURL = process.env.VUE_APP_URL 

Vue.prototype.$urlBase = process.env.VUE_APP_BASE

Vue.prototype.$urlDomain = process.env.VUE_APP_DOMAIN


Vue.prototype.$urlChat = process.env.VUE_APP_CHAT


Vue.prototype.$storage = process.env.VUE_APP_STORAGE
Vue.prototype.$titleSite = process.env.VUE_APP_TITLE
Vue.prototype.$subtitleSite = process.env.VUE_APP_SUBTITLE
Vue.prototype.$wlType = process.env.VUE_APP_WL_TYPE
// Add a 401 response interceptor
// axiosInstance.interceptors.response.use(function (response) {
//   return response;
// },  error => {
//   if (error.response.status === 401) {
//     this.$store.dispatch("LOGOUT");
//     this.$router.push({ name: "login" });
//   }
// });